<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center flex-1">
        <h6 class="modal-title">
          <ng-container i18n>Notifications</ng-container>&nbsp;
          <span [hidden]="!unreadCount" class="badge badge-danger badge-pill">{{ unreadCount }}</span>
        </h6>
        <div class="flex-fill"></div>
        <!--
        <a class="text-sm text-link" (click)="onReadAll()">
          <i class="cs-icon cs-icon-check-double text-xs"></i> <ng-container i18n>Mark all as read</ng-container></a
        >
        -->
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="container-box">
        <ul class="nav top-navbar border-bottom text-sm">
          <li *ngFor="let tab of tabs" [class.active]="activeTab === tab" (click)="onTabClick(tab)">
            <a class=""> {{ tab.title }} {{ tab.amount }} </a>
          </li>
        </ul>
        <ul class="list-unstyled m-0 p-0 text-sm">
          <ng-container [ngSwitch]="activeTab.id">
            <ng-container *ngSwitchCase="'incident'">
              <ng-template [ngTemplateOutlet]="incidentsTmpl"></ng-template>
              <ng-template
                [ngTemplateOutlet]="emptyTmpl"
                [ngTemplateOutletContext]="{ count: incidents.length }"
              ></ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'task'">
              <ng-template [ngTemplateOutlet]="tasksTmpl"></ng-template>
              <ng-template
                [ngTemplateOutlet]="emptyTmpl"
                [ngTemplateOutletContext]="{ count: tasks.length }"
              ></ng-template>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <ng-template [ngTemplateOutlet]="notificationsTmpl"></ng-template>
              <ng-template
                [ngTemplateOutlet]="emptyTmpl"
                [ngTemplateOutletContext]="{ count: notifications.length }"
              ></ng-template>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>
</div>
<ng-template #emptyTmpl let-count="count">
  <app-empty-table *ngIf="!count">
    <img [src]="activeTab.emptyImage" alt="Empty" class="empty-image" />
    <h5 class="empty-title">{{ activeTab.emptyTitle }}</h5>
    <p>{{ activeTab.emptyDescription }}</p>
  </app-empty-table>
  <mat-paginator2
    #paginator
    [length]="count"
    [hidden]="!count"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)"
  >
  </mat-paginator2>
</ng-template>

<ng-template #notificationsTmpl>
  <ng-container *ngFor="let item of paginatedNotifications">
    <li class="border-bottom notification-item" *ngIf="theme[item.type] as typeTheme" [ngClass]="typeTheme.color">
      <a
        (click)="onOpen(item)"
        class="p-2 d-flex align-items-center gap-3 text-default"
        [class.disabled]="!typeTheme.clickable"
      >
        <div class="badge badge-circle" [ngClass]="'badge-secondary-' + typeTheme.color" style="--size: 2rem">
          <i [ngClass]="typeTheme.icon" class="text-md"></i>
        </div>
        <div class="flex-fill">
          <div class="text-truncate" [innerHTML]="getTitleHtml(item.title, typeTheme.color)"></div>
          <div class="text-truncate">{{ item.subject }}</div>
        </div>
        <div class="text-xs text-light">
          {{ item.date | timeAgo }}
        </div>
      </a>
    </li>
  </ng-container>
</ng-template>

<ng-template #tasksTmpl>
  <ng-container *ngFor="let item of paginatedTasks">
    <li class="border-bottom notification-item" *ngIf="getTaskStatusColor(item) as color">
      <a (click)="onOpenTask(item)" class="p-2 d-flex align-items-center gap-3 text-default">
        <div class="badge badge-circle" [ngClass]="'badge-secondary-' + color" style="--size: 2rem">
          <i class="text-md fas fa-list-check"></i>
        </div>
        <div class="flex-fill text-truncate">
          <div class="text-truncate">{{ item.name }}</div>
          <ul class="dot-segments-list text-sm">
            <li class="text-semi-bold" [ngClass]="'text-' + color">
              <app-task-status [task]="item" [badge]="false"></app-task-status>
            </li>
            <li>
              {{ item.usersView | titleCase }}
            </li>
            <li *ngIf="item.rental_id">
              <app-rental-name [rentalId]="item.rental_id" class="d-inline-flex"></app-rental-name>
            </li>
          </ul>
        </div>
        <div class="text-xs text-light text-nowrap">
          {{ item.created | timeAgo }}
        </div>
      </a>
    </li>
  </ng-container>
</ng-template>

<ng-template #incidentsTmpl>
  <ng-container *ngFor="let item of paginatedIncidents">
    <li class="border-bottom notification-item">
      <a
        (click)="onOpenIncident(item)"
        class="p-2 d-flex align-items-center gap-3 text-default"
        *ngIf="getIncidentSeverityColor(item.severity) as color"
      >
        <div class="badge badge-circle" [ngClass]="'badge-secondary-' + color" style="--size: 2rem">
          <i [ngClass]="getIncidentSeverityIcon(item.severity)" class="text-md"></i>
        </div>
        <div class="flex-fill text-truncate">
          <div class="text-truncate">{{ item.title }}</div>
          <ul class="dot-segments-list text-sm">
            <li [ngClass]="'text-' + color" class="text-semi-bold" *ngIf="item.severity">
              {{ item.severity | titleCase }}
            </li>
            <li *ngIf="item.status">
              {{ item.status | titleCase }}
            </li>
            <li *ngIf="item.categories?.length">
              {{ item.categories | titleCase }}
            </li>
            <li *ngIf="item.rental_id">
              <app-rental-name [rentalId]="item.rental_id" class="d-inline-flex"></app-rental-name>
            </li>
          </ul>
        </div>
        <div class="text-xs text-light text-nowrap">
          {{ item.created | timeAgo }}
        </div>
      </a>
    </li>
  </ng-container>
</ng-template>
